module.exports = __webpack_public_path__ + "static/media/AnswerWhite.4c1f0cd0.svg";